import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, FileText, Package, ClipboardList, Target, Coins, MessageSquare, FolderOpen, GraduationCap, ArrowRight } from "lucide-react";
import { usePartner } from "./PartnerLayout";
import { useAuth } from "../../contexts/AuthContext";

const CARDS = {
  commandes: { to: "/partner/commandes", label: "Commandes à traiter", icon: ShoppingCart, url: "/partner/orders", count: (d) => d.filter((o) => !o.supplier_status || o.supplier_status !== "delivered").length },
  factures: { to: "/partner/factures", label: "Factures déposées", icon: FileText, url: "/partner/invoices", count: (d) => d.length },
  catalogue: { to: "/partner/catalogue", label: "Produits référencés", icon: Package, url: "/partner/catalogue", count: (d) => d.length },
  missions: { to: "/partner/missions", label: "Missions en cours", icon: ClipboardList, url: "/partner/missions", count: (d) => d.filter((m) => m.status !== "validee").length },
  leads: { to: "/partner/leads", label: "Leads apportés", icon: Target, url: "/partner/leads", count: (d) => d.length },
  commissions: { to: "/partner/commissions", label: "Commissions en attente", icon: Coins, url: "/partner/commissions", count: (d) => `${d.total_due} €` },
  sessions: { to: "/partner/formation", label: "Mes sessions", icon: GraduationCap, url: "/partner/lms/sessions", count: (d) => d.length },
  messagerie: { to: "/partner/messages", label: "Messages", icon: MessageSquare, url: "/partner/messages", count: (d) => d.length },
  documents: { to: "/partner/documents", label: "Documents partagés", icon: FolderOpen, url: "/partner/documents", count: (d) => d.length },
};

export default function PartnerHome() {
  const me = usePartner();
  const { axiosAuth } = useAuth();
  const [counts, setCounts] = useState({});
  const b = me.branding || {};
  const keys = Object.keys(CARDS).filter((k) => me.access?.[k]);

  useEffect(() => {
    keys.forEach((k) => axiosAuth().get(CARDS[k].url).then((r) => setCounts((c) => ({ ...c, [k]: CARDS[k].count(Array.isArray(r.data) ? r.data : r.data) }))).catch(() => {}));
    // eslint-disable-next-line
  }, []);

  return (
    <div data-testid="partner-home">
      <div className="text-[10px] uppercase tracking-[0.25em] font-bold mb-2" style={{ color: b.primary }}>{me.societe_name}</div>
      <h1 className="text-3xl md:text-4xl font-black text-white leading-tight" data-testid="partner-welcome-title">{b.welcome_title || `Bienvenue ${me.partner?.name || ""}`}</h1>
      <p className="text-sm text-slate-400 mt-2 max-w-xl">{b.welcome_text}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-8">
        {keys.map((k) => {
          const c = CARDS[k];
          return (
            <Link key={k} to={c.to} className="group rounded-2xl border border-white/10 bg-white/[0.03] p-5 hover:border-white/25 transition-colors" data-testid={"partner-card-" + k}>
              <c.icon className="w-5 h-5 mb-3" style={{ color: b.accent || "#38bdf8" }} />
              <div className="text-2xl font-black text-white">{counts[k] ?? "—"}</div>
              <div className="text-xs text-slate-400 flex items-center gap-1">{c.label} <ArrowRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" /></div>
            </Link>
          );
        })}
        {keys.length === 0 && <div className="col-span-full text-sm text-slate-500 italic">Aucun module n'est activé pour votre compte. Contactez votre interlocuteur.</div>}
      </div>
    </div>
  );
}
